module.exports = __webpack_public_path__ + "assets/img/NPC026.241706de.png";